"use client";

import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  MoreHorizontal,
  Trash2,
  Star,
  Calendar,
  Download,
  MessageSquare,
  CheckCircle,
  XCircle,
  Clock,
  AlertCircle,
  Phone,
  Mail,
  MessageCircle,
} from "lucide-react";
import { Button } from "../UI/Button";
import { Input } from "../UI/Input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../UI/table";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../UI/dropdown-menu";
import { Badge } from "../UI/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../UI/tabs";
import ReviewModal from "../UI/review-modal";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { URL_API } from "../../config/default";
import { myHeaders } from "../../config/axios";
import Error from "../../pages/Error/Index";
import moment from "moment/moment";
import Spinner from "../UI/Spinner/Spinner";
import { CustomToast } from "../../utils/custom-toast";
import CancelModal from "../UI/cancel-modal";
import ApprovedModal from "../UI/approved-modal";
import Pagination from "../../utils/pagination";
import ApprovedPaymentModal from "../UI/approved-payment-modal";
import { useAdminContext } from "../../contexts/AdminProvider";
import { Menu } from '@headlessui/react';

export default function BookingsTable() {
  const { me }: any = useAdminContext();
  const queryClient = useQueryClient();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("all");
  const [selectedBooking, setSelectedBooking] = useState<any>(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showApprovedPaymentModal, setShowApprovedPaymentModal] = useState(false);
  const [showApprovedModal, setShowApprovedModal] = useState(false);
  const [motivo, setMotivo] = useState<any>("");
  const [calificacion, setCalificacion] = useState({
    description: "",
    cleanliness: 0,
    truthgulness: 0,
    checkin: 0,
    communication: 0,
    location: 0,
    price_quality: 0,
    user: [0],
  });

  const [loading, setLoading] = useState<any>(false);
  const [filter, setFilter] = useState<{
    end_date?: any;
    start_date?: any;
    status?: any;
    customer?: string;
  }>({
    //end_date: moment(new Date()).format("YYYY-MM-D"),
    //customer: "1",
  });

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "pre-pending":
        return (
          <Badge className="bg-yellow-100 text-yellow-800 hover:bg-yellow-100">
            <Clock className="w-3 h-3 mr-1" />
            Pre Reserva
          </Badge>
        );
      case "approved":
        return (
          <Badge className="bg-green-100 text-green-800 hover:bg-green-100">
            <CheckCircle className="w-3 h-3 mr-1" />
            Aprobada
          </Badge>
        );
      case "pending":
        return (
          <Badge className="bg-yellow-100 text-yellow-800 hover:bg-yellow-100">
            <Clock className="w-3 h-3 mr-1" />
            Pendiente
          </Badge>
        );
      case "cancel":
        return (
          <Badge className="bg-red-100 text-red-800 hover:bg-red-100">
            <XCircle className="w-3 h-3 mr-1" />
            Cancelada
          </Badge>
        );
      case "rejected":
        return (
          <Badge className="bg-red-100 text-red-800 hover:bg-red-100">
            <AlertCircle className="w-3 h-3 mr-1" />
            Rechazada
          </Badge>
        );
      default:
        return <Badge variant="secondary">{status}</Badge>;
    }
  };

  const handleOpenReview = (booking: any) => {
    setSelectedBooking(booking);
    setShowReviewModal(true);
  };

  const handleOpenCancel = (booking: any) => {
    setSelectedBooking(booking);
    setShowCancelModal(true);
  };

  const handleOpenApprovedBooking = (booking: any) => {
    setSelectedBooking(booking);
    setShowApprovedPaymentModal(true);
  };

  const handleOpenApproved = (booking: any) => {
    setSelectedBooking(booking);
    setShowApprovedModal(true);
  };

  const handleSendMessage = (booking: any) => {
    //const url = `https://wa.me/549${booking.seller[0]?.phone}?text=${encodeURIComponent('Hola, te escribo desde la plataforma.')}`
    
    const url = `/chat/${booking.conversation[0]?.id}`;

    return window.open(url, '_blank');
  }

  const onClick = (e: any, value: any) => {
    switch (e.target.name) {
      case "approved": {
        setLoading(true);
        let formdata = new FormData();
        formdata.append("status", "approved");
        formdata.append("property", selectedBooking.property[0].title);
        formdata.append("customer_email", selectedBooking.customer[0].email);
        formdata.append("phone", selectedBooking.customer[0].phone);

        const requestOptions = {
          method: "POST",
          body: formdata,
          headers: {
            Authorization: myHeaders,
          },
        };
        fetch(`${URL_API}/reservations/${selectedBooking.id}`, requestOptions)
          .then(async (response) => {
            const result: any = await response.json();
            console.log(result);
            if (response.ok) {
              CustomToast({
                status: 200,
                msg: "",
                title:
                  "Reserva aprobada. se enviara un mail de aprobacion con los datos de la reserva",
              });

              queryClient.invalidateQueries({
                queryKey: ["index-reservas", filter],
              });

              setLoading(false);
              setSelectedBooking(null);
              setShowApprovedModal(false);
            }

            //return navigate("/");
          })
          .then((result) => console.log(result))
          .catch((error) => console.error(error));
      } break;
      case "calificar":
        {
          setLoading(true);
          let formdata = new FormData();
          if (value.property_id)
            formdata.append("property_id", value.property_id);
          if (value.excursion_id)
            formdata.append("excursion_id", value.excursion_id);

          formdata.append("booking_id", value.id);
          formdata.append("description", calificacion.description);
          formdata.append("cleanliness", String(calificacion.cleanliness));
          formdata.append("truthgulness", String(calificacion.truthgulness));
          formdata.append("checkin", String(calificacion.checkin));
          formdata.append("communication", String(calificacion.communication));
          formdata.append("location", String(calificacion.location));
          formdata.append("price_quality", String(calificacion.price_quality));

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };
          fetch(`${URL_API}/reviews`, requestOptions)
            .then(async (response) => {
              //const result: any = await response.json();
              if (response.ok) {
                CustomToast({
                  status: 200,
                  msg: "",
                  title: "Reseña enviada",
                });

                setCalificacion({
                  description: "",
                  cleanliness: 0,
                  truthgulness: 0,
                  checkin: 0,
                  communication: 0,
                  location: 0,
                  price_quality: 0,
                  user: [0],
                });

                setLoading(false);
                setSelectedBooking(null);
                setShowCancelModal(false);
              }
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      case "cancelar":
        {
          setLoading(true);
          let formdata = new FormData();
          formdata.append("status", "cancel");
          formdata.append("motivo", motivo);
          formdata.append("owner_id", selectedBooking.property[0].owner_id);
          formdata.append("property", selectedBooking.property[0].title);
          formdata.append("customer_email", selectedBooking.customer[0].email);
          formdata.append("phone", selectedBooking.customer[0].phone);

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders,
            },
          };
          fetch(`${URL_API}/reservations/${selectedBooking.id}`, requestOptions)
            .then(async (response) => {
              const result: any = await response.json();
              console.log(result);
              if (response.ok) {
                CustomToast({
                  status: 200,
                  msg: "",
                  title:
                    "Reserva cancelada. el propietario se comunicara via mail o numero de telefono proximamente",
                });

                queryClient.invalidateQueries({
                  queryKey: ["index-reservas", filter],
                });

                setLoading(false);
                setSelectedBooking(null);
                setShowCancelModal(false);
              }

              //return navigate("/");
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      case "pendiente":
        {
          setLoading(true);
          let formdata = new FormData();
          formdata.append("status", "pending");
          formdata.append("motivo", motivo);
          formdata.append("owner_id", selectedBooking.property[0].owner_id);
          formdata.append("property", selectedBooking.property[0].title);
          formdata.append("customer_email", selectedBooking.customer[0].email);
          formdata.append("phone", selectedBooking.customer[0].phone);

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders,
            },
          };
          fetch(`${URL_API}/reservations/${selectedBooking.id}`, requestOptions)
            .then(async (response) => {
              const result: any = await response.json();
              console.log(result);
              if (response.ok) {
                CustomToast({
                  status: 200,
                  msg: "",
                  title:
                    "Reserva aprobada, se enviara un mail para que realice el pago de reserva",
                });

                queryClient.invalidateQueries({
                  queryKey: ["index-reservas", filter],
                });

                setLoading(false);
                setSelectedBooking(null);
                setShowCancelModal(false);
              }

              //return navigate("/");
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      default:
        break;
    }
  };

  // Sincronizar activeTab con URL al cargar
  useEffect(() => {
    const tabFromUrl = searchParams.get('tab');
    const validTabs = ['all', 'upcoming', 'completed', 'cancelled', 'my-bookings'];

    if (tabFromUrl && validTabs.includes(tabFromUrl)) {
      setActiveTab(tabFromUrl);
    }
  }, []);

  // Actualizar filtros cuando cambia el tab activo
  useEffect(() => {
    const today = moment(new Date()).format("YYYY-MM-D");

    switch (activeTab) {
      case "upcoming":
        setFilter({ start_date: today });
        break;
      case "completed":
        setFilter({ status: "approved", end_date: today });
        break;
      case "cancelled":
        setFilter({ status: "cancel" });
        break;
      case "my-bookings":
        setFilter({ customer: "1" });
        break;
      default:
        setFilter({});
    }
  }, [activeTab]);

  // Función para cambiar de tab y actualizar la URL
  const handleTabChange = (value: string) => {
    setActiveTab(value);
    searchParams.set('tab', value);
    setSearchParams(searchParams);
  };

  const { isPending, error, data } = useQuery({
    queryKey: ["index-reservas", filter],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      const params = new URLSearchParams(filter);

      return fetch(`${URL_API}/reservations?${params}`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  if (isPending) {
    return (
      <div className="flex justify-center items-center py-5 text-black">
        <Spinner />
      </div>
    );
  }

  if (error) return <Error />;

  const bookings = data;

  return (
    <div className="space-y-4">
      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
        <div className="px-4 sm:px-6 pt-4">
          <TabsList className="grid w-full grid-cols-5">
            <TabsTrigger value="all" className="text-xs sm:text-sm">
              Todas
            </TabsTrigger>
            <TabsTrigger value="upcoming" className="text-xs sm:text-sm">
              Próximas
            </TabsTrigger>
            <TabsTrigger value="completed" className="text-xs sm:text-sm">
              Completadas
            </TabsTrigger>
            <TabsTrigger value="cancelled" className="text-xs sm:text-sm">
              Canceladas
            </TabsTrigger>
            <TabsTrigger value="my-bookings" className="text-xs sm:text-sm">
              Mis Reservas
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value={activeTab} className="space-y-4">
          {/* Filters and Actions */}
          <div className="flex flex-col sm:flex-row gap-4 p-4 sm:p-6">
            <div className="flex-1">
              <Input
                placeholder="Buscar reservas..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="max-w-sm"
              />
            </div>

            <div className="flex flex-wrap gap-2">
              <Button variant="outline" size="icon">
                <Download className="w-4 h-4" />
              </Button>
            </div>
          </div>


          {/* Cards - Mobile */}
          <div className="lg:hidden space-y-4 p-2">
            {bookings.data.map((booking: any) => (
              <div key={booking.id} className=" bg-white border rounded-lg p-4 space-y-3">
                {/* Header */}
                <div className="flex items-start justify-between">
                  <div className="flex-1 min-w-0">
                    <h3 className="font-medium text-gray-900">
                      {booking.firstname} {booking.lastname}
                    </h3>
                    <p className="text-sm text-gray-500 truncate">{booking.email}</p>
                    <p className="text-xs text-gray-400">ID: {booking.id}</p>
                  </div>
                  <div className="relative flex items-center gap-2 z-10">
                    {getStatusBadge(booking.status)}
                    <Menu as="div" className="relative inline-block text-left">
                      <Menu.Button className="p-2">
                        <MoreHorizontal className="w-4 h-4" />
                      </Menu.Button>
                      <Menu.Items className="bg-white absolute right-0 mt-2 w-40 origin-top-right p-1 shadow-lg rounded-md z-50">
                        {booking.status === "pre-pending" &&
                          (<Menu.Item>
                            <Button variant={'outline'}
                              className="w-full border-0"
                              onClick={() => handleOpenApproved(booking)}>
                              <CheckCircle className="mr-2 h-4 w-4" />
                              Aprobar reserva
                            </Button>
                          </Menu.Item>
                          )}
                        {booking.status === "pending" &&
                          (<Menu.Item><Button variant={'outline'}

                            className="w-full border-0 "
                            onClick={() => handleOpenApprovedBooking(booking)}>
                            <CheckCircle className="mr-2 h-4 w-4" />
                            Aprobar reserva
                          </Button></Menu.Item>)}
                        {activeTab === "all" &&
                          booking.reviews_property.length == 0 && (<Menu.Item><Button variant={'outline'}
                            className="w-full border-0"
                            onClick={() => handleOpenCancel(booking)}>
                            <Trash2 className="mr-2 h-4 w-4" />
                            Cancel reserva
                          </Button></Menu.Item>)}
                        {activeTab === "my-bookings" &&
                          booking.reviews_property.length == 0 && (
                            <Menu.Item><Button variant={'outline'}
                              className="w-full border-0"
                              onClick={() => handleOpenReview(booking)}>
                              <Star className="mr-2 h-4 w-4" />
                              Escribir reseña
                            </Button></Menu.Item>
                          )}
                        {activeTab === "my-bookings" &&
                          booking.reviews_property.length > 0 && (
                            <Menu.Item><Button variant={'outline'}
                              className="w-full border-0"
                              onClick={() => handleOpenReview(booking)}>
                              <MessageSquare className="mr-2 h-4 w-4" />
                              Ver mi reseña
                            </Button></Menu.Item>
                          )}
                        {/* Otros items */}
                      </Menu.Items>
                    </Menu>
                  </div>
                </div>

                {/* Service info */}
                <div className="bg-gray-50 rounded-lg p-3">
                  <div className="font-medium">{booking.property[0]?.title ||
                    booking.excursion[0]?.title ||
                    "N/A"}</div>
                  <div className="text-sm text-gray-500">{booking.property_id ? "Alojamiento" : "Excursión"}</div>
                </div>

                {/* Anfitrion */}
                <div className={`bg-gray-50 rounded-lg p-3 flex justify-between ${me?.role === 'admin' ? '' : 'hidden'}`}>
                  <div>
                    <div className="font-medium">{booking.seller[0]?.firstname + " " +
                      booking.seller[0]?.lastname}</div>
                    <div className="text-sm text-gray-500">{"Anfritión"}</div>
                  </div>
                  <Button onClick={() => handleSendMessage(booking)}>
                    <MessageCircle className="mr-2 h-4 w-4" />
                    Enviar mensaje
                  </Button>
                </div>

                {/* Dates */}
                <div className="flex items-center gap-2 text-sm">
                  <Calendar className="w-4 h-4 text-gray-400" />
                  <span>
                    {format(new Date(booking.start_date), "dd MMM", { locale: es })} -{" "}
                    {format(new Date(booking.end_date), "dd MMM yyyy", { locale: es })}
                  </span>
                </div>

                {/* Details grid */}
                <div className="grid grid-cols-2 gap-4 pt-3 border-t">
                  <div>
                    <div className="text-xs text-gray-500 uppercase tracking-wide">Huéspedes</div>
                    <div className="font-medium">{booking.guests}</div>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500 uppercase tracking-wide">Total</div>
                    <div className="font-medium">${booking.total.toFixed(2)}</div>
                  </div>
                  <div className={`${me?.role === 'admin' ? '' : 'hidden'}`}>
                    <div className="text-xs text-gray-500 uppercase tracking-wide">
                      Impuesto
                    </div>
                    <div className="font-medium text-green-600">${booking.executed.toFixed(2)}</div>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500 uppercase tracking-wide">Creada</div>
                    <div className="text-sm">{format(new Date(booking.created_at), "dd/MM/yyyy", { locale: es })}</div>
                  </div>
                </div>

                {/* Check-in/out times */}
                {
                  booking.property_id

                    ? <div className="text-xs text-gray-500 pt-2 border-t flex items-center">
                      <Calendar className="w-3 h-3" />
                      {' Check-In ' + booking.checkin}
                      {' Check-Out ' + booking.checkout}
                    </div>
                    : ""
                }
              </div>
            ))}


            {/* Table - Desktop */}
          </div><div className="hidden lg:block rounded-md border overflow-hidden">
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead className="w-[200px]">Cliente</TableHead>
                    {me?.role === 'admin' ? <TableHead className="w-[200px]">Anfitrión</TableHead> : ''}
                    <TableHead>Alojamiento/Excursión</TableHead>
                    <TableHead>Fechas</TableHead>
                    <TableHead>Huéspedes</TableHead>
                    <TableHead>Estado</TableHead>
                    <TableHead>Total</TableHead>
                    <TableHead>Impuesto</TableHead>
                    <TableHead>Creada</TableHead>
                    <TableHead className="text-right">Acciones</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {bookings.data.map((booking: any) => (
                    <TableRow key={booking.id}>
                      <TableCell>
                        <div>
                          <div className="font-medium text-gray-900">
                            {booking.firstname} {booking.lastname}
                          </div>
                          <div className="text-sm text-gray-500 mb-1 flex items-center">
                            <Mail className="w-[12px] h-[12px] me-1" />{booking.email}
                          </div>
                          <div className="text-xs text-gray-400 mb-1 flex items-center">
                            <Phone className="w-[12px] h-[12px] me-1" /> {booking.seller[0]?.phone}
                          </div>
                          <div className="text-xs text-gray-400">
                            ID: {booking.id}
                          </div>
                        </div>
                      </TableCell>
                      {me?.role === 'admin'
                        ? <TableCell>
                          <div>
                            <div className="font-medium text-gray-900">
                              {booking.seller[0]?.firstname} {booking.seller[0]?.lastname}
                            </div>
                            <div className="text-sm text-gray-500 mb-1 flex items-center">
                              <Mail className="w-[12px] h-[12px] me-1" /> {booking.seller[0]?.email}
                            </div>
                            <div className="text-xs text-gray-400 flex items-center">
                              <Phone className="w-[12px] h-[12px] me-1" /> {booking.seller[0]?.phone}
                            </div>
                          </div>
                        </TableCell> : ''}
                      <TableCell>
                        <div>
                          <div className="font-medium">
                            {booking.property[0]?.title ||
                              booking.excursion[0]?.title ||
                              "N/A"}
                          </div>
                          <div className="text-sm text-gray-500">
                            {booking.property_id ? "Alojamiento" : "Excursión"}
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="text-sm">
                          <div className="flex items-center gap-1 mb-1">
                            <Calendar className="w-3 h-3" />
                            {format(new Date(booking.start_date), "dd MMM", {
                              locale: es,
                            })}{" "}
                            -{" "}
                            {format(new Date(booking.end_date), "dd MMM yyyy", {
                              locale: es,
                            })}
                          </div>
                          <div className="text-xs text-gray-500">
                            Check-in: {booking.checkin} | Check-out:{" "}
                            {booking.checkout}
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="text-center">
                          <div className="font-medium">{booking.guests}</div>
                          <div className="text-xs text-gray-500">huéspedes</div>
                        </div>
                      </TableCell>
                      <TableCell>{getStatusBadge(booking.status)}</TableCell>
                      <TableCell>
                        <div className="text-sm">
                          <div className="font-medium">
                            ${booking.total.toFixed(2)}
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="font-medium text-green-600">
                          ${booking.executed.toFixed(2)}
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="text-sm text-gray-600">
                          {format(new Date(booking.created_at), "dd/MM/yyyy", {
                            locale: es,
                          })}
                        </div>
                      </TableCell>
                      <TableCell className="relative text-right">
                        <DropdownMenu>
                          <DropdownMenuTrigger asChild>
                            <Button variant="ghost" className="h-8 w-8 p-0">
                              <span className="sr-only">Abrir menú</span>
                              <MoreHorizontal className="h-4 w-4" />
                            </Button>
                          </DropdownMenuTrigger>
                          <DropdownMenuContent align="end">
                            {me?.role === 'admin' || me?.role == 'client'
                              ? <>
                                <DropdownMenuLabel>Contacto</DropdownMenuLabel>
                                <DropdownMenuSeparator />
                                <DropdownMenuItem
                                  onClick={() => handleSendMessage(booking)}
                                >
                                  <MessageCircle className="mr-2 h-4 w-4" />
                                  Enviar mensaje
                                </DropdownMenuItem>
                              </> : ''}
                            <DropdownMenuLabel>Acciones</DropdownMenuLabel>
                            {booking.status === "pre-pending" &&
                              (
                                <>
                                  <DropdownMenuSeparator />
                                  <DropdownMenuItem
                                    onClick={() => handleOpenApproved(booking)}
                                  >
                                    <CheckCircle className="mr-2 h-4 w-4" />
                                    Aprobar reserva
                                  </DropdownMenuItem>
                                </>
                              )}
                            {booking.status === "pending" &&
                              (
                                <>
                                  <DropdownMenuSeparator />
                                  <DropdownMenuItem
                                    onClick={() => handleOpenApprovedBooking(booking)}
                                  >
                                    <CheckCircle className="mr-2 h-4 w-4" />
                                    Aprobar pago
                                  </DropdownMenuItem>
                                </>
                              )}
                            {activeTab === "all" &&
                              booking.reviews_property.length == 0 && (
                                <>
                                  <DropdownMenuSeparator />
                                  <DropdownMenuItem
                                    onClick={() => handleOpenCancel(booking)}
                                  >
                                    <Trash2 className="mr-2 h-4 w-4" />
                                    Cancel reserva
                                  </DropdownMenuItem>
                                </>
                              )}
                            {activeTab === "my-bookings" &&
                              booking.reviews_property.length == 0 && (
                                <>
                                  <DropdownMenuSeparator />
                                  <DropdownMenuItem
                                    onClick={() => handleOpenReview(booking)}
                                  >
                                    <Star className="mr-2 h-4 w-4" />
                                    Escribir reseña
                                  </DropdownMenuItem>
                                </>
                              )}
                            {activeTab === "my-bookings" &&
                              booking.reviews_property.length > 0 && (
                                <>
                                  <DropdownMenuSeparator />
                                  <DropdownMenuItem
                                    onClick={() => handleOpenReview(booking)}
                                  >
                                    <MessageSquare className="mr-2 h-4 w-4" />
                                    Ver mi reseña
                                  </DropdownMenuItem>
                                </>
                              )}
                            <DropdownMenuSeparator />
                          </DropdownMenuContent>
                        </DropdownMenu>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>

          {/* Pagination */}
          <Pagination data={data} setPage={setFilter} page={filter} />
        </TabsContent>
      </Tabs>

      {/* Review Modal */}
      {showReviewModal && selectedBooking && (
        <ReviewModal
          onClick={onClick}
          calificacion={calificacion}
          setCalificacion={setCalificacion}
          loading={loading}
          booking={selectedBooking}
          onClose={() => {
            setShowReviewModal(false);
            setSelectedBooking(null);
          }}
        />
      )}

      {/* Cancel Modal */}
      {showCancelModal && selectedBooking && (
        <CancelModal
          onClick={onClick}
          setMotivo={setMotivo}
          loading={loading}
          motivo={motivo}
          booking={selectedBooking}
          onClose={() => {
            setShowCancelModal(false);
            setSelectedBooking(null);
          }}
        />
      )}

      {showApprovedModal && selectedBooking && (
        <ApprovedModal
          onClick={onClick}
          loading={loading}
          booking={selectedBooking}
          onClose={() => {
            setShowApprovedModal(false);
            setSelectedBooking(null);
          }}
        />
      )}

      {showApprovedPaymentModal && selectedBooking && (
        <ApprovedPaymentModal
          onClick={onClick}
          loading={loading}
          booking={selectedBooking}
          onClose={() => {
            setShowApprovedPaymentModal(false);
            setSelectedBooking(null);
          }}
        />
      )}
    </div>
  );
}
